import React, { Component, Fragment } from 'react';

export default class ReceiptLink extends Component {
    constructor(props) {
      super(props);

      this.props = props;

      this.baseURL = 'https://api.usezapay.com.br';

      // @ts-ignore
      if (process.env.NODE_ENV === 'development') {
        this.baseURL = 'http://localhost';
      }
    }

    render () {
        return (
            <Fragment>
                {this.props.status == 'Confirmado' ?
                  <a href={`${this.baseURL}/comprovante/${this.props.protocol}/`}
                    className="dropdown-item"
                    target="_blank">
                    Comprovante
                  </a>
                : <a href="#" className="dropdown-item">Comprovante</a>}
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/ReceiptLink.js